function getElementContent(element) {
  const template = element.querySelector('template');
  return template ? template.innerHTML : '';
}

export default getElementContent;
